<template>
	<ToolTip align="left" :aria-label="t('extra_night_breakdown_title')">
		<template #toggle>
			<InfoOutline class="size-3.5 text-ink-muted" />
		</template>
		<span class="block whitespace-pre-line">{{ t('extra_night_info_text') }}</span>
	</ToolTip>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import ToolTip from '@/components/ToolTip.vue';
import InfoOutline from '@thermenresorts/icons/svg/info.svg?component';

const { t } = useI18n();
</script>
